var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7589_5755)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7589_5755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7589_5755)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#C6DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90282 21.3824C8.9305 21.8158 8.95508 22.2676 8.774 22.6667C8.61675 23.0129 8.30654 23.3214 8.32114 23.698C8.32224 23.7244 8.32574 23.7529 8.34396 23.7731C8.36712 23.7987 8.40661 23.8038 8.44214 23.807C9.48689 23.9029 10.5356 23.9989 11.5841 23.9582C12.0176 23.9413 12.4495 23.9011 12.8823 23.8757C13.9578 23.8127 15.0395 23.842 16.1096 23.9627C15.832 23.0425 15.7003 22.0839 15.7203 21.1283",
    fill: "#F0B68F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42703 18.4624C8.0929 19.1664 7.58398 20.3697 7.30233 21.0981C7.1922 21.3828 7.0844 21.6837 7.12007 21.9881C7.14723 22.2189 7.25491 22.4299 7.36272 22.6335C8.16466 24.1482 9.07942 25.598 10.096 26.9657C10.1551 27.045 10.2175 27.1342 10.2109 27.2346C10.2058 27.3098 10.1622 27.3754 10.1201 27.4369C9.94017 27.7002 9.7602 27.9636 9.58023 28.2269C9.54923 28.2722 9.51015 28.3222 9.45674 28.3231C9.40594 28.3237 9.36655 28.2794 9.33427 28.2387C8.51233 27.2058 7.69039 26.1728 6.86845 25.1399C6.26494 24.3814 5.65714 23.6162 5.21463 22.7455C5.08281 22.4862 4.96434 22.2106 4.94871 21.9176C4.93664 21.6921 4.98611 21.4683 5.03941 21.2493C5.43716 19.6139 6.06247 18.0382 6.88972 16.587",
    fill: "#F0B68F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1413 18.6008C16.4506 19.316 16.9172 20.5364 17.1733 21.2741C17.2734 21.5625 17.3707 21.867 17.3244 22.17C17.2892 22.3997 17.1742 22.6068 17.0594 22.8065C16.205 24.2923 15.2402 25.7093 14.1765 27.0407C14.1148 27.1178 14.0492 27.2048 14.0524 27.3054C14.0548 27.3808 14.0961 27.4479 14.136 27.5108C14.3067 27.7802 14.4773 28.0497 14.648 28.3191C14.6774 28.3655 14.7147 28.4169 14.7681 28.4195C14.8188 28.4219 14.8597 28.3791 14.8934 28.3395C15.7509 27.3359 16.6084 26.3323 17.4659 25.3286C18.0955 24.5917 18.7296 23.8481 19.2022 22.9934C19.343 22.7389 19.471 22.4676 19.4969 22.1753C19.5168 21.9504 19.4752 21.725 19.4296 21.5042C19.0891 19.8559 18.5192 18.2594 17.7431 16.7802",
    fill: "#F0B68F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7589_5755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 10,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72656 1.99219L16.0053 2.13669L15.8268 12.3634L7.54805 12.2189L7.72656 1.99219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7589_5755)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7589_5755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 2,
    width: 9,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5289 9.5435C15.54 9.36782 15.6179 9.20475 15.6828 9.04146C15.8995 8.49675 15.9703 7.84199 15.6618 7.34538C15.5057 7.0943 15.2645 6.90293 15.1313 6.63859C14.9826 6.34303 14.987 5.99511 14.9134 5.67164C14.8033 5.1884 14.5066 4.75147 14.101 4.47536C13.9815 4.39397 13.8521 4.32864 13.7178 4.27639C13.9003 3.91055 13.9046 3.45324 13.7349 3.07665C13.5267 2.61443 13.0895 2.27999 12.6071 2.14475C12.1249 2.00968 11.6036 2.06109 11.131 2.22872C10.6994 2.38202 10.2943 2.63697 10.0133 3.00348C9.73204 3.36998 9.58566 3.85456 9.67392 4.31023C9.71311 4.51261 9.8048 4.7041 9.93098 4.86577C9.5097 5.20966 9.16618 5.6467 9.08473 6.17889C9.03255 6.5188 9.09229 6.87348 9.00307 7.20522C8.83795 7.81885 8.22424 8.1828 7.88274 8.71609C7.38717 9.49009 7.55266 10.59 8.16015 11.276C8.76782 11.9621 9.73394 12.252 10.6379 12.1602C10.97 12.1265 11.2969 12.0464 11.6299 12.0261C12.6729 11.9624 13.7103 12.4853 14.7378 12.2926C14.9727 12.2485 15.2058 12.1646 15.3901 12.0099C15.5627 11.865 15.6845 11.6643 15.7595 11.4502C15.8795 11.1076 15.883 10.7243 15.7693 10.3796C15.6776 10.1019 15.5105 9.8358 15.5289 9.5435Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7589_5755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5289 9.5435C15.54 9.36782 15.6179 9.20475 15.6828 9.04146C15.8995 8.49675 15.9703 7.84199 15.6618 7.34538C15.5057 7.0943 15.2645 6.90293 15.1313 6.63859C14.9826 6.34303 14.987 5.99511 14.9134 5.67164C14.8033 5.1884 14.5066 4.75147 14.101 4.47536C13.9815 4.39397 13.8521 4.32864 13.7178 4.27639C13.9003 3.91055 13.9046 3.45324 13.7349 3.07665C13.5267 2.61443 13.0895 2.27999 12.6071 2.14475C12.1249 2.00968 11.6036 2.06109 11.131 2.22872C10.6994 2.38202 10.2943 2.63697 10.0133 3.00348C9.73204 3.36998 9.58566 3.85456 9.67392 4.31023C9.71311 4.51261 9.8048 4.7041 9.93098 4.86577C9.5097 5.20966 9.16618 5.6467 9.08473 6.17889C9.03255 6.5188 9.09229 6.87348 9.00307 7.20522C8.83795 7.81885 8.22424 8.1828 7.88274 8.71609C7.38717 9.49009 7.55266 10.59 8.16015 11.276C8.76782 11.9621 9.73394 12.252 10.6379 12.1602C10.97 12.1265 11.2969 12.0464 11.6299 12.0261C12.6729 11.9624 13.7103 12.4853 14.7378 12.2926C14.9727 12.2485 15.2058 12.1646 15.3901 12.0099C15.5627 11.865 15.6845 11.6643 15.7595 11.4502C15.8795 11.1076 15.883 10.7243 15.7693 10.3796C15.6776 10.1019 15.5105 9.8358 15.5289 9.5435Z",
    fill: "url(#paint0_linear_7589_5755)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.13281,
    y: 5.38281,
    width: 6.22831,
    height: 9.34247,
    transform: "rotate(1 5.13281 5.38281)",
    fill: "url(#pattern0_7589_5755)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8003 13.0323C13.8103 12.7298 13.6574 12.0511 13.6574 12.0511C13.5041 10.8587 13.5739 10.3288 13.6931 10.006C12.9288 9.95332 12.1694 9.93858 11.4039 9.88386C11.3259 9.87823 11.254 9.86401 11.1873 9.84398C11.262 10.0281 11.5892 10.9508 11.134 12.007C11.134 12.007 10.5762 12.6546 9.32574 12.855C8.07524 13.0554 7.52294 13.5657 7.51691 14.1854C7.51234 14.6754 10.9439 14.7269 12.3788 14.727C13.8128 14.777 16.9482 15.2968 16.9606 14.807C16.9763 14.1875 16.5746 13.3918 15.3318 13.1479L14.8003 13.0323Z",
    fill: "#F39C81"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4817 8.1636C10.4096 8.07852 10.3276 7.99688 10.2216 7.94069C10.1158 7.88465 9.98272 7.85674 9.86265 7.88572C9.74717 7.91347 9.6557 7.99122 9.60853 8.08231C9.56136 8.17326 9.55483 8.27619 9.57152 8.37461C9.60142 8.55 9.71407 8.72467 9.90424 8.80762C10.0946 8.89072 10.3634 8.85379 10.4732 8.70237C10.546 8.60204 10.5397 8.47649 10.5223 8.35999",
    fill: "#F0B68F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.006 8.22674C14.081 8.14423 14.1658 8.0655 14.2737 8.01304C14.3814 7.96072 14.5153 7.93748 14.6345 7.97063C14.7488 8.0024 14.8374 8.08329 14.8814 8.17597C14.9254 8.26851 14.9283 8.3716 14.9082 8.46938C14.8722 8.64362 14.7535 8.81426 14.5606 8.89052C14.3675 8.96692 14.1001 8.92063 13.9957 8.76548C13.9265 8.66267 13.9369 8.53741 13.9586 8.42159",
    fill: "#F0B68F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9795 8.08602C14.0171 8.04473 14.0595 8.00535 14.1133 7.97921C14.1674 7.95307 14.2342 7.94141 14.2937 7.95793C14.351 7.97379 14.3953 8.01427 14.4172 8.06067C14.4393 8.10688 14.4407 8.15842 14.4307 8.20732C14.4126 8.29456 14.3533 8.37987 14.2568 8.41789C14.1603 8.45612 14.0266 8.43301 13.9743 8.35533C13.9399 8.30403 13.945 8.2414 13.9558 8.18355",
    fill: "#FC7F51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2079 6.18589C9.97818 7.1601 10.0314 8.1952 10.3599 9.14346C10.459 9.42949 10.5845 9.71096 10.7753 9.95017C10.9778 10.2043 11.2473 10.4024 11.5321 10.5678C11.7099 10.6713 11.8975 10.7642 12.1 10.8086C12.4953 10.8952 12.921 10.7851 13.2508 10.5586C13.5806 10.3322 13.747 10.1583 13.9808 9.75081C14.1444 9.46534 14.2257 9.15147 14.3011 8.83347C14.3984 8.42304 14.4537 7.8745 14.4477 7.45339C14.4442 7.2007 14.4032 6.95002 14.3598 6.70082C14.2687 6.17837 14.1388 5.61119 13.7088 5.28052C13.2471 4.92533 12.5834 4.95865 12.0116 5.09978",
    fill: "url(#paint1_linear_7589_5755)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0223 4.12879C11.3167 4.01388 10.5952 4.43924 10.1702 5.07569C9.74501 5.71214 9.58455 6.526 9.58304 7.3163C9.58306 7.33349 9.58339 7.35176 9.59219 7.3657C9.6109 7.39575 9.65226 7.38752 9.68333 7.37553C10.0408 7.23871 10.3816 7.04698 10.7472 6.9402C11.0581 6.84948 11.3836 6.82204 11.7029 6.85966C11.76 6.86639 11.8255 6.87201 11.8669 6.82761C11.8947 6.79765 11.9031 6.75232 11.9103 6.71001C11.9701 6.35134 12.0261 5.99207 12.0788 5.6322C12.2801 5.98826 12.3785 6.41505 12.3558 6.83525C12.3534 6.88032 12.3523 6.93313 12.3841 6.96161C12.4042 6.97951 12.4318 6.98178 12.4576 6.98331C12.5806 6.99083 12.7038 6.99835 12.8268 7.00569C12.8852 7.00939 12.9513 7.01001 12.9933 6.96455C13.0312 6.92367 13.0364 6.85966 13.0393 6.80134C13.0486 6.61368 13.058 6.42602 13.0674 6.23853C13.262 6.49636 13.4047 6.80217 13.4821 7.12742C13.7301 7.23363 13.9781 7.33984 14.2261 7.44605C14.2461 7.45464 14.2667 7.46341 14.2883 7.46307C14.3587 7.46179 14.3966 7.37185 14.4133 7.29605C14.5299 6.76397 14.424 6.19811 14.2249 5.69813C13.9117 4.91092 13.3216 4.21342 12.5628 4.02757",
    fill: "#222B54"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13432 12.7408C9.13432 12.7408 11.5187 14.9724 15.618 13.1971C15.618 13.1971 16.4918 13.3867 16.8559 14.0067C17.2202 14.6268 18.6599 17.4874 18.6599 17.4874L16.227 19.027C16.227 19.027 16.0066 20.7738 15.8272 21.7884C15.8272 21.7884 10.5581 22.4033 8.64307 21.663C8.64307 21.663 8.31743 19.3267 8.29134 18.8368L5.98586 17.9731C5.98586 17.9731 7.17218 14.072 7.76956 13.4633L9.13432 12.7408Z",
    fill: "url(#paint2_linear_7589_5755)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17889 18.0355C9.68365 18.2116 10.0793 18.3356 10.3659 18.4077C10.6524 18.4797 11.0235 18.4862 11.4793 18.4271C11.7413 18.4142 12.0446 18.3794 12.389 18.3228C12.9056 18.2377 14.7426 18.8356 15.4914 17.9596C16.2402 17.0835 15.714 18.8526 14.3614 18.829C13.0088 18.8053 13.1398 18.6053 12.3807 18.7944C11.6217 18.9835 9.93834 19.1814 9.17276 18.3868C8.66237 17.8572 8.66441 17.7401 9.17889 18.0355Z",
    fill: "#AB0F3F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7589_5755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 22,
    width: 13,
    height: 33
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78608 22.4707C7.86657 23.4445 7.54751 24.8926 7.26971 26.2575C7.01781 27.4958 6.76454 28.745 6.75081 30.0126C6.73849 31.1513 6.91986 32.2795 7.07912 33.4043C7.63261 37.3098 7.92833 41.2597 7.96347 45.2132C7.98947 48.1597 7.90706 51.2738 9.23012 53.8368C9.28845 53.9498 9.35643 54.0681 9.46556 54.119C9.55087 54.1587 9.64759 54.1507 9.74013 54.1418C10.2016 54.0981 10.6631 54.0544 11.1248 54.0105C11.1921 54.0041 11.2669 53.9939 11.311 53.9377C11.3463 53.8928 11.3527 53.8299 11.3576 53.7711C11.9817 46.2299 11.3682 38.5962 12.3225 31.0953C13.3516 38.7221 14.6291 46.308 16.1521 53.8338C16.1827 53.9857 16.3043 54.0935 16.4465 54.0993C17.0464 54.1243 17.6519 54.0678 18.2597 53.8205C18.3414 53.7872 18.4015 53.7067 18.4165 53.6128C18.6696 52.0279 18.4998 50.3996 18.3405 48.799C17.6645 42.0076 17.1933 35.1911 16.9276 28.3644C16.8562 26.5284 16.7771 24.6037 15.9184 23.0263C15.8826 22.9605 15.8413 22.8917 15.7766 22.8621C15.7038 22.8289 15.6207 22.8541 15.5445 22.8771C14.5271 23.1866 13.4493 23.0864 12.3988 22.984C11.1936 22.8666 9.99124 22.5882 8.78608 22.4707Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7589_5755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78608 22.4707C7.86657 23.4445 7.54751 24.8926 7.26971 26.2575C7.01781 27.4958 6.76454 28.745 6.75081 30.0126C6.73849 31.1513 6.91986 32.2795 7.07912 33.4043C7.63261 37.3098 7.92833 41.2597 7.96347 45.2132C7.98947 48.1597 7.90706 51.2738 9.23012 53.8368C9.28845 53.9498 9.35643 54.0681 9.46556 54.119C9.55087 54.1587 9.64759 54.1507 9.74013 54.1418C10.2016 54.0981 10.6631 54.0544 11.1248 54.0105C11.1921 54.0041 11.2669 53.9939 11.311 53.9377C11.3463 53.8928 11.3527 53.8299 11.3576 53.7711C11.9817 46.2299 11.3682 38.5962 12.3225 31.0953C13.3516 38.7221 14.6291 46.308 16.1521 53.8338C16.1827 53.9857 16.3043 54.0935 16.4465 54.0993C17.0464 54.1243 17.6519 54.0678 18.2597 53.8205C18.3414 53.7872 18.4015 53.7067 18.4165 53.6128C18.6696 52.0279 18.4998 50.3996 18.3405 48.799C17.6645 42.0076 17.1933 35.1911 16.9276 28.3644C16.8562 26.5284 16.7771 24.6037 15.9184 23.0263C15.8826 22.9605 15.8413 22.8917 15.7766 22.8621C15.7038 22.8289 15.6207 22.8541 15.5445 22.8771C14.5271 23.1866 13.4493 23.0864 12.3988 22.984C11.1936 22.8666 9.99124 22.5882 8.78608 22.4707Z",
    fill: "url(#paint3_linear_7589_5755)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7589_5755",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7589_5755",
    transform: "scale(0.111111 0.0714286)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7589_5755",
    x1: 11.6874,
    y1: 12.2912,
    x2: 11.7898,
    y2: 6.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47568D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7589_5755",
    x1: 12.2498,
    y1: 7.9133,
    x2: 12.1988,
    y2: 10.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7589_5755",
    x1: 12.409,
    y1: 12.798,
    x2: 12.2486,
    y2: 21.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A51239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7589_5755",
    x1: 12.9702,
    y1: 22.5438,
    x2: 12.4221,
    y2: 53.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#396688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132F44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7589_5755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7589_5755",
    width: 9,
    height: 14,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAABSElEQVR4AV3BvXLTQBSA0e/eu1optmXIj5kJDB0FDTN0PAYvzQNQp01BwZhxLMeSdrV78RBoOMf4T99/VZFCKb/4R/jjltXqo/X9oLW2sZSYch7cXcvp9N2Fi93ucxtCiKpXr1TyGjjnzHmeh+dx6qag+knMNAZrPsCyBlmJytA0ZNH+UdSTtu1ZVNotcA/sgOLV78BXjclNCEcL2+3GRJoOcgU2wD0wAlcVRpFNoyktpjq/Ad4Bb4EbhB54L0gnMiUdR8sQDsCWF9c4d0BF3KdpTQjBxL1uRTgCAXBgABaBCRYJMVYXZY/zQ+DWIQEZOLqTVDJBdfJpfD10XfrpMPBCuKjVnp1IcDcXXQZ3OQi1cyErEh15KlWeoC4WY8uyXBe1MiMqIXguhUNK5VT9eNrvH6rwl9kX+n4ObWvRzOo8x7Tff6tc/AaXK5hUsQ98+AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanIcon);
export default __webpack_public_path__ + "static/media/woman-icon.d0d76049aebeb2d7ac44d87b77618278.svg";
export { ForwardRef as ReactComponent };